module.exports = __webpack_public_path__ + "img/trial3-2.4f4e0382.png";